/** biome-ignore-all lint/suspicious/noExplicitAny: Allowing any for flexibility as HTTP request could be anything */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  EfpServiceUserNotificationService,
  NotificationType
} from '@ats/service-user-notification';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ToastSuppressionService } from '../services/toast-suppression.service';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  constructor(
    private userNotification: EfpServiceUserNotificationService,
    private translate: TranslocoService,
    private toastSuppression: ToastSuppressionService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isMutating = req.method !== 'GET' && req.method !== 'OPTIONS';
    // HttpService (from @ats/api-sdk) can't set request headers, so callers using it
    // opt out via ToastSuppressionService instead of the x-ats-suppress-message header.
    // Only consume the flag for mutating requests so an unrelated GET in-flight can't eat it.
    const isSuppressed =
      isMutating &&
      (req.headers.has('x-ats-suppress-message') || this.toastSuppression.consumeSuppression());
    const toastmessage = !isMutating
      ? null
      : isSuppressed
        ? null
        : req.headers.has('x-ats-suppress-message')
          ? null
          : req.headers.has('x-ats-success')
            ? req.headers.get('x-ats-success')
            : req.method === 'POST'
              ? this.translate.translate('Common.Create operation successful')
              : req.method === 'PATCH'
                ? this.translate.translate('Common.Update operation successful')
                : req.method === 'DELETE'
                  ? this.translate.translate('Common.Delete operation successful')
                  : this.translate.translate('Common.Operation successful');

    return next.handle(req).pipe(
      tap((resp) => {
        if (resp instanceof HttpResponse && toastmessage !== null) {
          this.userNotification.show({
            text: this.translate.translate('Common.Success') as string,
            message: decodeURIComponent(toastmessage),
            type: NotificationType.Success
          });
        }
      }),
      catchError((error) => {
        this.userNotification.show({
          text: this.translate.translate('Common.Error') as string,
          message: this.translate.translate(
            'Common.There was an error performing this operation'
          ) as string,
          instruction: error.error?.detail,
          type: NotificationType.Error
        });

        return throwError(() => error);
      })
    );
  }
}

@Injectable()
export class ToastEncodeInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let updatedRequest = req;

    if (req.headers.has('x-ats-success')) {
      updatedRequest = req.clone({
        setHeaders: {
          'x-ats-success': encodeURIComponent(req.headers.get('x-ats-success') ?? '')
        }
      });
    }

    return next.handle(updatedRequest);
  }
}

// @Injectable()
// export class ToastEncodeInterceptor implements HttpInterceptor {
//   constructor() {}

//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<unknown>> {
//     let updatedRequest = req;

//     if (req.headers.has('x-ats-success')) {
//       updatedRequest = req.clone({
//         headers: req.headers.set(
//           'x-ats-success',
//           encodeURIComponent(req.headers.get('x-ats-success') ?? '')
//         )
//       });
//     }

//     return next.handle(updatedRequest);
//   }
// }
